import React from 'react';
import CurrencyText from '../../../../../../components/ui/labels/CurrencyText';

const SimpleInfo = ({ title, value }) => {
  const profitTextColor = (value) => {
    if (value > 0) return 'text-blueHighlight';
    if (value < 0) return 'text-redDeep';
    return '';
  };
  return (
    <div className="bg-blueLight items-center p-4 gap-4" style={{ borderRadius: '12px' }}>
      {/* TEXT */}
      <div className="flex flex-col gap-1 min-w-0">
        <span className="text-blueDarker text-base font-semibold truncate">{title}</span>
        <CurrencyText value={value || 0} size="normal" className={profitTextColor(value)} />
      </div>
    </div>
  );
};

export default SimpleInfo;
